"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
class Environment {
    static getName() {
        return process.env.NODE_ENV || 'development';
    }
    static isDevelopment() {
        return ['development'].indexOf(this.getName().toLowerCase()) >= 0;
    }
    static isProduction() {
        return ['production'].indexOf(this.getName().toLowerCase()) >= 0;
    }
}
exports.Environment = Environment;
//# sourceMappingURL=EnvironmentUtil.js.map